import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

export const customRoutes = []

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: []
})
export class CustomLibRoutesModule {}
